import * as React from 'react';

import { Wrapper } from './styles';
import Utils from '../../../utils';

interface CheckboxProps {
	name: string;
	label?: string | React.ReactNode;
	isChecked: boolean;
	onChange: (e: React.FormEvent<HTMLInputElement>) => void;
}

const Checkbox = ({
	name,
	label,
	isChecked,
	onChange,
}: CheckboxProps) => (
	<Wrapper>
		<label>
			<input
				type="checkbox"
				name={name}
				checked={isChecked}
				onChange={onChange}
			/>
			{isChecked && Utils.getSvgIcon('iconset_check-1')}
			{label}
		</label>
	</Wrapper>
);

export default Checkbox;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/Checkbox/index.tsx